import { useMemo } from "react";

import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";

const useIsActive = () => {
  const { activeContentKey } = useMemberToolbarStore();

  const isActive = useMemo(() => {
    return activeContentKey === contentKeys.login;
  }, [activeContentKey]);

  return isActive;
};

export { useIsActive };
